
























































import {Prop, Component} from 'vue-property-decorator';
import ATableRow from "@common/table/components/table-list/ATableRow.vue";
import {TableItem} from "@api/models/interfaces/TableItem";
import {UserProfile} from "@api/models/UserProfile";
import {EventBus} from '@common/EventBus';
import {TooltipDirective} from '@share/directives/Tooltip';
import {TableColumn} from "@common/table/interfaces/TableColumn";
import { dateToFormatFromIso } from "@common/dateTimeHelper";
import UsersListItem from '@share/common/users-list/UsersListItem.vue'
import {Ticket} from "@api/models/tickets/Ticket";
import {TicketField} from "@share/ticketSystem/enums/TicketFields";

@Component({
    components: {UsersListItem},
    directives: {TooltipDirective}
})

export default class TableRow extends ATableRow {
    @Prop({required: true}) declare source: Ticket;

    TicketField = TicketField;
    formatDate = 'dd.LL.yyyy';

    getField(item: TableItem, field: TableColumn) {
        let value = item.getField(field.fieldName);

        if (
            field.fieldName === TicketField.ownerIds &&
            this.source.owner
        ) {
            value = this.source.owner.fullName;
        }

        if (
            field.fieldName === TicketField.responsibleUserId &&
            this.source.responsibleUser
        ) {
            value = this.source.responsibleUser.fullName;
        }

        if (([TicketField.status, TicketField.category, TicketField.company] as string[]).includes(field.fieldName) && value) {
            value = value.title ?? '';
        }

        if (field.type && field.type === 'DateTime' && value) {
            value = dateToFormatFromIso(value, this.formatDate);
        }

        return value;
    }

    getStatusColor(tableItem: TableItem) {
        let value = tableItem.getField(TicketField.status);
        let color: string | null = null;
        if (value && value.color) {
            color = value.color;
        }
        return color;
    }

    select(user: UserProfile | null) {
        if (user && this.$store.getters['userId'] !== user.userId) {
            EventBus.$emit("showChatByUserId", user.userId);
        }
    }

    toRoute(id: string) {
        this.$emit('saveScrollPosition', this.index);
        this.$router.push({
            name: this.routeName,
            params: {
                id
            }
        })
    }
}
